import {
    LOADING_TOGGLE_ACTION,
    LOGIN_CONFIRMED_ACTION,
    LOGIN_FAILED_ACTION,
    LOGOUT_ACTION,
} from '../actions/AuthActions';

const AZURE_FILE_SHARE_BASE = 'https://infusionstorage.file.core.windows.net/praxxis-files/tenants';
const AZURE_SAS_TOKEN = 'sv=2026-02-06&ss=f&srt=o&sp=r&se=2036-06-11T08:05:29Z&st=2026-06-10T23:50:29Z&spr=https&sig=WCpqlPbnvauOcrbJceli96437ngjUHjZU42nVTP7LBk%3D';

const EMPTY_TENANT_CONFIG = {
    client_name:             '',
    patient_images_path:     '',
    eligibility_images_path: '',
    id_card_images_path:     '',
    documents_path:          '',
    staff_images_path:       '',
    product_images_path:     '',
    azure_sas_token:         '',
    // Per-tenant toggle for in-app patient creation. Defaults to true so tenants
    // whose config omits it are unaffected; import-only tenants send false.
    // buildTenantConfig spreads the incoming tenant_config over this, so an
    // explicit false from the backend overrides the default.
    allow_patient_creation:  true,
};

function buildTenantConfig(tenantConfig, customerNumber) {
    const cfg = { ...EMPTY_TENANT_CONFIG, ...(tenantConfig || {}) };
    if (!cfg.azure_sas_token) cfg.azure_sas_token = AZURE_SAS_TOKEN;
    if (customerNumber) {
        const base = `${AZURE_FILE_SHARE_BASE}/${customerNumber}`;
        if (!cfg.patient_images_path)     cfg.patient_images_path     = `${base}/patient_images`;
        if (!cfg.eligibility_images_path) cfg.eligibility_images_path = `${base}/eligibility_images`;
        if (!cfg.id_card_images_path)     cfg.id_card_images_path     = `${base}/id_card_images`;
        if (!cfg.documents_path)          cfg.documents_path          = `${base}/documents`;
        if (!cfg.staff_images_path)       cfg.staff_images_path       = `${base}/staff_images`;
        if (!cfg.product_images_path)     cfg.product_images_path     = `${AZURE_FILE_SHARE_BASE.replace('/tenants', '')}/global/product_images/global_drug_images`;
    }
    return cfg;
}

const initialState = {
    auth: {
        username: '',
        full_name: '',
        user_id: null,
        photo_filename: '',
        customerNumber: '',
        access: '',
        refresh: '',
        expireDate: '',
        mustChangePassword: false,
        tenantConfig: { ...EMPTY_TENANT_CONFIG },
    },
    errorMessage: '',
    successMessage: '',
    showLoading: false,
};

export function AuthReducer(state = initialState, action) {
    if (action.type === LOGIN_CONFIRMED_ACTION) {
        return {
            ...state,
            auth: {
                username: action.payload.username || '',
                full_name: action.payload.full_name || action.payload.username || '',
                user_id: action.payload.user_id || null,
                photo_filename: action.payload.photo_filename || '',
                customerNumber: action.payload.customer_number || '',
                access: action.payload.access || '',
                refresh: action.payload.refresh || '',
                expireDate: action.payload.expireDate || '',
                mustChangePassword: !!action.payload.must_change_password,
                tenantConfig: buildTenantConfig(action.payload.tenant_config, action.payload.customer_number),
            },
            errorMessage: '',
            successMessage: 'Login Successful',
            showLoading: false,
        };
    }

    if (action.type === LOGOUT_ACTION) {
        return {
            ...state,
            auth: {
                username: '',
                full_name: '',
                user_id: null,
                photo_filename: '',
                customerNumber: '',
                access: '',
                refresh: '',
                expireDate: '',
                mustChangePassword: false,
                tenantConfig: { ...EMPTY_TENANT_CONFIG },
            },
            errorMessage: '',
            successMessage: '',
        };
    }

    if (action.type === LOGIN_FAILED_ACTION) {
        return {
            ...state,
            errorMessage: action.payload,
            successMessage: '',
            showLoading: false,
        };
    }

    if (action.type === LOADING_TOGGLE_ACTION) {
        return {
            ...state,
            showLoading: action.payload,
        };
    }

    return state;
}
